/**
 * The sentence to show for a failed better-auth call. A 429 — the API's
 * sign-in, two-factor and email throttles — always reads as "wait", with the
 * server's `Try again in …` when it sent one, rather than as a wrong password.
 */
export function authErrorMessage(
  error: { status?: number; message?: string } | null | undefined,
  fallback: string,
): string {
  if (error?.status === 429) {
    return error.message && /try again/i.test(error.message)
      ? error.message
      : "Too many attempts. Wait a few minutes and try again.";
  }
  return error?.message || fallback;
}
